import { TKey } from "@/app/translations/TKey";
import { BillingMeter } from "@/app/types/billing/BillingMeter";
import { CreditBucket } from "@/app/types/billing/CreditWallet";
import { UWallet } from "@/app/utils/UWallet";

export const BILLING_METERS: BillingMeter[] = [
  {
    labelKey: TKey.PLAN_USAGE_CALLS,
    used: (wallet, plan) => UWallet.usedCallHours(wallet, plan),
    left: (wallet, planActive) => UWallet.spendableHours(wallet, planActive),
  },
  {
    labelKey: TKey.PLAN_USAGE_PROSPECTS,
    used: (wallet, plan) => UWallet.usedProspects(wallet, plan),
    left: (wallet, planActive) => UWallet.spendableProspects(wallet, planActive),
  },
];

export const TOP_UP_TABS: { bucket: CreditBucket; labelKey: TKey }[] = [
  { bucket: CreditBucket.CALL, labelKey: TKey.TOPUP_TAB_CALLS },
  { bucket: CreditBucket.PROSPECT, labelKey: TKey.TOPUP_TAB_PROSPECTS },
];

export function currentPath(): string {
  if (typeof window === "undefined") {
    return "/";
  }
  return `${window.location.pathname}${window.location.search}`;
}
